import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';

function BookingButton() {
  const navigate = useNavigate();
  const location = useLocation();
  const availableBooking = [];

  const getBranchInfo = () => {
    const path = location.pathname;
    
    if (path.includes('/jakarta-branch')) {
      return {
        whatsAppLink: 'https://wa.link/pd7i7s',
        branchName: 'Jakarta Branch'
      };
    } else if (path.includes('/arizona-branch')) {
      return {
        whatsAppLink: 'https://wa.link/5rr8r6',
        branchName: 'Arizona Branch'
      };
    } else if (path.includes('/boston-branch')) {
      return {
        whatsAppLink: 'https://wa.link/6zr1cr',
        branchName: 'Boston Branch'
      };
    } else {
      // Default case
      return {
        whatsAppLink: 'https://wa.link/ndrq7d',
        branchName: 'Booking'
      };
    }
  };

  const handleClick = () => {
    if (availableBooking.length === 0) {
      const { whatsAppLink, branchName } = getBranchInfo();
      
      Swal.fire({
        title: 'Mohon Maaf',
        html: `
          <div class="text-center">
            <p class="text-gray-600 mb-4">Fitur booking online untuk ${branchName} segera hadir!</p>
            <p class="text-gray-600">Untuk sementara, Anda dapat melakukan reservasi melalui WhatsApp.</p>
          </div>
        `,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Hubungi via WhatsApp',
        cancelButtonText: 'Tutup',
        confirmButtonColor: '#9333ea',
        cancelButtonColor: '#6B7280',
        background: '#ffffff',
        customClass: {
          title: 'text-xl font-bold text-gray-800',
          htmlContainer: 'text-base',
          actions: 'mt-4',
          confirmButton: 'px-6 py-2 rounded-lg text-white font-medium',
          cancelButton: 'px-6 py-2 rounded-lg text-white font-medium'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          window.open(whatsAppLink, '_blank');
        }
      });
    } else {
      navigate('/jobs');
    }
  };

  return (
    <button 
      onClick={handleClick}
      className="bg-white text-purple-600 px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-all duration-300 transform hover:scale-105 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-50">
      Booking Sekarang
    </button>
  );
}

export default BookingButton;